// extracted by mini-css-extract-plugin
export default {"root":"PrimaryPanel_root__gBVao"};